import React, { FC, useCallback } from 'react'
import styled from '@emotion/styled'

import { Spin, PageWrapper, Button, HandleBtns, Tags, ImgLoad } from 'components'
import { useNftDetail } from 'core/nft/api/useNftDetail'
import { useApiError } from 'shared/hooks'

import defImg from 'assets/default.png'
import editImg from 'assets/edit.png'
import deleteImg from 'assets/delete.png'

export const NftDetail: FC = () => {
    const {
        methods: { handleError }
    } = useApiError('NftDetail')
    const {
        loading,
        detail,
        methods: { syncData }
    } = useNftDetail()

    const syncDataHandle = useCallback(() => {
        detail?.token_address &&
            detail?.token_id &&
            syncData(detail?.token_address, detail?.token_id).catch(handleError)
    }, [detail, syncData, handleError])

    return (
        <Spin spinning={loading}>
            <Wrapper>
                {detail && (
                    <div className="main">
                        <div className="detail-info">
                            <div className="img">
                                <ImgLoad loadingImg={defImg} errorImg={defImg} src={detail.image_url} />
                            </div>
                            <div className="info">
                                <div className="info-header">
                                    <div className="title">{detail.name}</div>
                                    {/* <HandleBtns
                                        buttons={[
                                            {
                                                icon: editImg,
                                                link: `/nft/${detail.id}/edit`
                                            }
                                            {
                                                icon: deleteImg,
                                                link: ''
                                            }
                                        ]}
                                    /> */}
                                </div>
                                <Tags tags={detail.tags} />
                                <div className="info-items">
                                    <div className="item">
                                        <label>Owner address:</label>
                                        <span>{detail.owner}</span>
                                    </div>
                                    <div className="item">
                                        <label>Token ID:</label>
                                        <span>{detail.token_id}</span>
                                    </div>
                                    <div className="item">
                                        <label>Description:</label>
                                        <div>{detail.description}</div>
                                    </div>
                                </div>
                                {!detail?.upload && (
                                    <Button className="sync-metadata" onClick={syncDataHandle}>
                                        Sync Metadata
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Wrapper>
        </Spin>
    )
}

const Wrapper = styled(PageWrapper)`
    min-height: 500px;
    .main {
        padding: 72px 0;
    }
    .detail-info {
        display: flex;
        .img {
            width: 524px;
            img {
                width: 100%;
                height: auto;
            }
        }
        .info {
            margin-left: 50px;
            width: calc(100% - 574px);
            min-width: 460px;
            .info-header {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
            }
            .title {
                font-family: HelveticaNeue-CondensedBold;
                font-size: 50px;
                line-height: 50px;
                color: #000;
                letter-spacing: 0;
            }
            .info-items {
                font-family: Roboto-Regular;
                font-size: 20px;
                color: #000;
                letter-spacing: 0;
                .item {
                    margin: 30px 0;
                    word-break: break-all;
                    label {
                        color: #787878;
                        display: inline-block;
                        margin-right: 10px;
                    }
                    span {
                        user-select: all;
                    }
                }
            }
            .sync-metadata {
                font-family: Roboto-Medium;
                font-size: 26px;
                color: #fff;
                letter-spacing: 0;
                text-align: center;
                line-height: 31px;
                margin: 40px 0;
            }
        }
    }
`
